import { mapToList } from "./utils";

// 售后订单菜单类型枚举（menuType）
export const EnumAfterSaleMenuType = {
  // 客服跟进逾期订单
  CUSTOMER_SERVICE_OVERDUE: 1,
  // 法务诉讼订单
  LEGAL_LITIGATION: 2,
  // 委外跟进订单
  OUTSOURCED_FOLLOW_UP: 3,
  // 债转订单
  DEBT_TRANSFER: 4,
  // 空置待处理订单
  IDLE_PENDING: 5,
  // 售后明细
  AFTER_SALES_DETAILS: 6,
  // 催收跟进订单
  COLLECTION_FOLLOW_UP: 7,
};

// menuType 到文字的映射
export const AfterSaleMenuTypeToTextMap = new Map([
  [EnumAfterSaleMenuType.CUSTOMER_SERVICE_OVERDUE, "客服跟进逾期订单"],
  [EnumAfterSaleMenuType.LEGAL_LITIGATION, "法务诉讼订单"],
  [EnumAfterSaleMenuType.OUTSOURCED_FOLLOW_UP, "委外跟进订单"],
  [EnumAfterSaleMenuType.DEBT_TRANSFER, "债转订单"],
  [EnumAfterSaleMenuType.IDLE_PENDING, "空置待处理订单"],
  [EnumAfterSaleMenuType.AFTER_SALES_DETAILS, "售后明细"],
  [EnumAfterSaleMenuType.COLLECTION_FOLLOW_UP, "催收跟进订单"],
]);

// menuType 到导出文件名的映射
export const AfterSaleMenuTypeToFileNameMap = new Map([
  [EnumAfterSaleMenuType.CUSTOMER_SERVICE_OVERDUE, "客服跟进逾期订单"],
  [EnumAfterSaleMenuType.LEGAL_LITIGATION, "法务诉讼订单"],
  [EnumAfterSaleMenuType.OUTSOURCED_FOLLOW_UP, "委外跟进订单"],
  [EnumAfterSaleMenuType.DEBT_TRANSFER, "债转订单"],
  [EnumAfterSaleMenuType.IDLE_PENDING, "空置待处理订单"],
  [EnumAfterSaleMenuType.AFTER_SALES_DETAILS, "售后明细"],
  [EnumAfterSaleMenuType.COLLECTION_FOLLOW_UP, "催收跟进订单"],
]);

// 流转操作类型枚举（actionType）
export const EnumAfterSaleActionType = {
  // 移交法务
  LEGAL: 1,
  // 移交客服
  CUSTOMER_SERVICE: 2,
  // 移交外包
  OUTSOURCED: 3,
  // 移交债转
  DEBT: 4,
  // 空置待处理
  IDLE: 5,
  // 无需法诉
  NO_LAWSUIT: 6,
  // 委外完成
  OUTSOURCED_COMPLETED: 7,
  // 无需债转
  NO_DEBT_TRANSFER: 8,
  // 债转完成
  DEBT_COMPLETED: 9,
  // 法诉完成
  LAWSUIT_COMPLETED: 10,
  // 催收跟进
  COLLECTION_FOLLOW_UP: 11,
};

// actionType 到文字的映射
export const AfterSaleActionTypeToTextMap = new Map([
  [EnumAfterSaleActionType.LEGAL, "移交法务"],
  [EnumAfterSaleActionType.CUSTOMER_SERVICE, "移交客服"],
  [EnumAfterSaleActionType.OUTSOURCED, "移交外包"],
  [EnumAfterSaleActionType.DEBT, "移交债转"],
  [EnumAfterSaleActionType.IDLE, "空置待处理"],
  [EnumAfterSaleActionType.NO_LAWSUIT, "无需法诉"],
  [EnumAfterSaleActionType.OUTSOURCED_COMPLETED, "委外完成"],
  [EnumAfterSaleActionType.NO_DEBT_TRANSFER, "无需债转"],
  [EnumAfterSaleActionType.DEBT_COMPLETED, "债转完成"],
  [EnumAfterSaleActionType.LAWSUIT_COMPLETED, "法诉完成"],
  [EnumAfterSaleActionType.COLLECTION_FOLLOW_UP, "催收跟进"],
]);

// 订单售后状态枚举
export const EnumAfterSaleStatus = {
  // 客服跟进
  PLATFORM_COMMUNICATION: "2001",
  // 待起诉
  PENDING_LITIGATION: "3001",
  // 法院起诉中
  LITIGATION_IN_PROGRESS: "3002",
  // 已调解
  MEDIATED: "3003",
  // 待执行
  PENDING_EXECUTION: "3004",
  // 执行中
  EXECUTING: "3005",
  // 已判决
  ADJUDICATED: "3006",
  // 法诉完成
  LAWSUIT_COMPLETED: "4001",
  // 空置待处理
  IDLE_PENDING: "5001",
  // 委外
  OUTSOURCED: "7001",
  // 债权转让中
  DEBT_TRANSFERRING: "9001",
  // 债转完成
  DEBT_TRANSFER_COMPLETED: "10001",
  // 催收跟进
  COLLECTION_FOLLOW_UP: "12001",
};

// 售后状态到文字的映射
export const AfterSaleStatusToTextMap = new Map([
  [EnumAfterSaleStatus.PLATFORM_COMMUNICATION, "客服跟进"],
  [EnumAfterSaleStatus.PENDING_LITIGATION, "待起诉"],
  [EnumAfterSaleStatus.LITIGATION_IN_PROGRESS, "法院起诉中"],
  [EnumAfterSaleStatus.MEDIATED, "已调解"],
  [EnumAfterSaleStatus.PENDING_EXECUTION, "待执行"],
  [EnumAfterSaleStatus.EXECUTING, "执行中"],
  [EnumAfterSaleStatus.ADJUDICATED, "已判决"],
  [EnumAfterSaleStatus.LAWSUIT_COMPLETED, "法诉完成"],
  [EnumAfterSaleStatus.IDLE_PENDING, "空置待处理"],
  [EnumAfterSaleStatus.OUTSOURCED, "委外"],
  [EnumAfterSaleStatus.DEBT_TRANSFERRING, "债权转让中"],
  [EnumAfterSaleStatus.DEBT_TRANSFER_COMPLETED, "债转完成"],
  [EnumAfterSaleStatus.COLLECTION_FOLLOW_UP, "催收跟进"],
]);

// 售后状态列表（用于下拉选择等场景）
export const AfterSaleStatusList = mapToList(AfterSaleStatusToTextMap);

// 根据售后状态值获取文字描述
export function getAfterSaleStatusText(status) {
  return AfterSaleStatusToTextMap.get(status) || "";
}

// 法务诉讼订单售后状态列表（用于查询和选择）
export const LegalLitigationAfterSaleStatusList = [
  {
    label: "待起诉",
    value: EnumAfterSaleStatus.PENDING_LITIGATION,
  },
  {
    label: "法院起诉中",
    value: EnumAfterSaleStatus.LITIGATION_IN_PROGRESS,
  },
  {
    label: "已调解",
    value: EnumAfterSaleStatus.MEDIATED,
  },
  {
    label: "待执行",
    value: EnumAfterSaleStatus.PENDING_EXECUTION,
  },
  {
    label: "执行中",
    value: EnumAfterSaleStatus.EXECUTING,
  },
  {
    label: "已判决",
    value: EnumAfterSaleStatus.ADJUDICATED,
  },
];
